module.exports = __webpack_public_path__ + "img/collage_stitching.d0665fc.svg";